import { render, staticRenderFns } from "./Interessi.vue?vue&type=template&id=54d94925&"
import script from "./Interessi.vue?vue&type=script&lang=js&"
export * from "./Interessi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports